<template>
  <div>
    <!-- <div :class="isShow?'search-panel bg-panel':'search-panel'"> -->
    <div class="search-panel bg-panel">
      <div class="button-panel">
        <van-row>
          <van-col span="3"><van-icon name="ellipsis" color="#ffffff" size="25" @click="openMenu" /></van-col>
          <van-col span="15">
            <div style="color: white; font-size: 20px; font-weight: bold;" @click="clickToHome">
              Acheter²
              <!-- <img src="../assets/Acheter.gif" width="110px" height="22px"> -->
            </div>
          </van-col>
          <van-col span="3">
            <van-badge dot v-if="notificationCount !== 0" >
              <div style="text-align: right">
                <van-icon name="contact-o" color="#ffffff" size="25" @click="openUserInfoOrLogin" />
              </div>
            </van-badge>
            <div style="text-align: right" v-else>
              <van-icon name="contact-o" color="#ffffff" size="25" @click="openUserInfoOrLogin" />
            </div>
          </van-col>
          <van-col span="3">
            <div style="text-align: right">
              <van-icon name="shopping-cart-o" color="#ffffff" size="25" @click="toShoppingCart" />
            </div>
          </van-col>
        </van-row>
      </div>
      <div>
        <van-search shape="round" right-icon="search" left-icon="false" background="none" v-model="keyword"
          :placeholder="placeholder" @search="onSearch" @click-right-icon="onSearch"
          class="app-search-icon">
        </van-search>
      </div>
    </div>
    <van-popup ref="popupRef" v-model="showPopup" :position="popupPosition" :style="{ height: '100%', width: '80%' }"
      duration="0.2" :key="popupPosition"
      :overlay-class="popupPosition === 'right' ? 'close-button-right' : 'close-button-left'">
      <PopupMainMenu v-if="current === 'menu'" :data="menuList" @return-home="clickReturnHome" @click-user-name="openUserInfoOrLogin"
        @menu-item-click="clickMenuItem" />
      <PopupSubMenu v-else-if="current === 'sub'" :category="selectedCategory" @back-to-main-menu="backToMainMenu"
        @click-menu-item="clickMenuItem" />
      <PopupUserInfo v-else-if="current === 'userInfo'" @click-brose="clickBrose"
        @logout="logout" @click-user-info="clickUserInfo" @password-change="clickPasswordChange" @close-popup="closePopup" />
    </van-popup>
  </div>
</template>

<script>
import PopupMainMenu from '@/components/PopupMainMenu.vue'
import PopupSubMenu from '@/components/PopupSubMenu.vue'
import PopupUserInfo from '@/components/PopupUserInfo.vue'
import * as PopupMenuService from '@/services/PopupMenuService'
import * as session from '@/plugins/session'
export default {
  name: 'IndexHead',
  props: {
    isShow: Boolean
  },
  components: {
    PopupMainMenu,
    PopupSubMenu,
    PopupUserInfo,
  },
  data() {
    return {
      keyword: '',
      typeId: null,
      topTypeId: null,
      placeholder: this.$t('view.app.searchAll'),
      showPopup: false,
      current: '',
      selectedCategory: null,
      menuList: [],
      popupPosition: '',
      notificationCount: 0
    }
  },
  mounted() {
    // 监听密码修改成功事件
    this.$root.$on('password-change', this.clickPasswordChange)
    // 恢复搜索关键字
    this.$root.$on('set-key-word',(keyWord)=>{
      this.keyword = keyWord
    })
    // 监听通知数量变化事件
    // 初始化通知数量
    if (sessionStorage.getItem('notification_count') === null || sessionStorage.getItem('notification_count') === '') {
      sessionStorage.setItem('notification_count', '0')
    }
    this.notificationCount = parseInt(sessionStorage.getItem('notification_count'))
    this.$root.$on('notification-count-change',(count)=>{
      this.notificationCount = parseInt(count)
    })
  },
  beforeUnmount(){
    // 移除事件监听器，避免内存泄漏
    this.$root.$off('password-change')
    this.$root.$off('set-key-word')
    this.$root.$off('notification-count-change')
  },
  methods: {
    openMenu() {
      PopupMenuService.getProductCategory().then(res => {
        this.menuList = res
      })
      this.popupPosition = 'left'
      this.current = 'menu'
      this.showPopup = true
    },
    clickMenuItem(category) {
      if (category.children && category.children.length > 0) {
        this.selectedCategory = category
        this.current = 'sub'
      } else {
        this.showPopup = false
        this.$router
          .push({
            path: '/search',
            query: {
              typeId: category.id || null
            }
          })
          .catch(() => { })
      }
    },
    backToMainMenu() {
      this.current = 'menu'
    },
    closePopup(){
      this.showPopup = false
    },
    clickReturnHome() {
      this.showPopup = false
      this.$router.push('/').catch(() => { })
    },
    clickToHome() {
      this.$router.push('/').catch(() => { })
    },
    openUserInfoOrLogin() {
      if (sessionStorage.getItem('user_id') !== null && sessionStorage.getItem('user_id') !== '') {
        this.popupPosition = 'right'
        this.current = 'userInfo'
        this.showPopup = true
      } else {
        this.openLogin()
      }
    },
    clickBrose() {
      this.openMenu()
    },
    logout() {
      this.showPopup = false
      // 触发Home组件更新登录状态
      this.$root.$emit('logout-success')

      // 跳转到登录页面
      session.clean()
      this.$router.go(0).then(()=>{
        this.$router.replace('/login')
      })
    },
    clickUserInfo() {
      this.showPopup = false
      this.$router.push('/userInfo').catch(() => { })
    },
    toShoppingCart() {
      if(this.$route.fullPath !== '/shoppingCart'){
        this.$router.push('/shoppingCart')
      }
    },
    openLogin() {
      // 跳转到登录页面
      this.$router.push('/login')
    },
    onSearch() {
      // 保存搜索关键字到sessionStorage
      this.$router.push({path: '/search',query:{name: this.keyword}}).catch(() => { })
      this.showPopup = false
    },
    clickPasswordChange() {
      this.showPopup = false
      // 触发Home组件更新登录状态
      this.$root.$emit('logout-success')
      session.clean()
      this.$router.go(0).then(()=>{
        this.$router.replace('/login')
      })
    }
  }
}
</script>

<style>
.search-panel {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
}

.bg-panel{
  background: linear-gradient(
    135deg,
    #ffb347 0%,      /* 亮橙 */
    #ff8c00 30%,     /* 深橙 */
    #ff6600 60%,     /* 橙红 */
    #cc5200 100%     /* 暗橙棕 */
  );
}

.button-panel {
  padding: 10px 20px;
}

.close-button-left::after {
  content: '';
  background-image: url(@/assets/svg/close.svg);
  background-size: 20px 20px;
  background-repeat: no-repeat;
  position: absolute;
  top: 40px;
  right: 8vw;
  width: 20px;
  height: 20px;
}

.close-button-right::after {
  content: '';
  background-image: url(@/assets/svg/close.svg);
  background-size: 20px 20px;
  background-repeat: no-repeat;
  position: absolute;
  top: 40px;
  left: 8vw;
  width: 20px;
  height: 20px;
}

.van-search__content{
  border: 2px solid #f7f8fa;
  background-color: transparent !important;
}

.van-search-new-content{
  background-color: #f7f8fa !important;
}

.search-input{
  color: #fff !important;
}

.app-search-icon .van-field__right-icon .van-icon {
  font-size: 23px !important;
}
.van-search__content{
  background-color: #fff !important;
}
</style>